(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var sections = Array.prototype.slice.call(main.children).filter(function (el) {
      return el.classList && el.classList.contains('shopify-section');
    });

    // Skip the first section (hero) - it has its own entrance animation and is above the fold.
    var revealTargets = sections.slice(1);

    revealTargets.forEach(function (section) {
      section.classList.add('scroll-reveal');
    });

    if (!('IntersectionObserver' in window)) {
      revealTargets.forEach(function (section) {
        section.classList.add('is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
    );

    revealTargets.forEach(function (section) {
      observer.observe(section);
    });
  });
})();
